import { useState } from 'react';

export const useIssueSummary = () => {
  const [issueSummary, setIssueSummary] = useState('');

  return {
    issueSummary,
    handleIssueSummaryChange: (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value || '';
      if (value.length < 255) {
        setIssueSummary(value);
      }
    },
  };
};
